// it's called "default", but is actually "dense"
export const DEFAULT_ROW_STYLE = "default";
